import { NgModule } from "@angular/core";
import { RevenuePerProductComponent } from "./RevenuePerProductComponent/revenue-per-product.component";
import {
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatTableModule,
    MatCardModule,
    MatTooltipModule,
    MatPaginatorModule,
    MatSpinner,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatSlideToggleModule,
    MatHint,
    MatSortModule,
    MatRadioModule,
    MatSelectModule,
    MatCheckboxModule,
    MatOptionModule,
    MatDatepickerModule,
} from "@angular/material";
import { FormsModule } from "@angular/forms";
import { RevenueService } from "../services/revenue.service";
import { ProductCategoryService } from "../services/product-category.service";
import { PrintService } from "../services/print.service";
import { CommonModule } from "@angular/common";

@NgModule({
    declarations: [RevenuePerProductComponent],
    imports: [
        CommonModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatOptionModule,
        MatButtonModule,
        MatIconModule,
        MatCardModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatDatepickerModule,
        FormsModule,
    ],
    exports: [RevenuePerProductComponent],
    providers: [RevenueService, ProductCategoryService, PrintService],
})
export class RevenueModule {}



// WEBPACK FOOTER //
// /app/src/RevenueModule/revenue.module.ts